<script setup lang="ts">
import { useRouter } from 'vue-router'
import { formatCurrency } from '~/utils/formatters'
import { useGlobalSalaryPeriod } from '~/composables/useGlobalSalaryPeriod'
import type { SalaryRole } from '~/composables/useCompanySalaryData'

interface Props {
  role: SalaryRole
  url: string
}
const props = defineProps<Props>()
const router = useRouter()
const { activePeriod, displayPeriods, adjustValueForPeriod }
  = useGlobalSalaryPeriod()
const navigateTo = (path: string) => {
  router.push(path)
}
const hourlyPay = computed(() => {
  if (activePeriod.value === 'hourly') {
    return adjustValueForPeriod(props.role.annual_pay)
  }
  return props.role.hourly_pay || props.role.annual_pay / 2080
})
const annualPay = computed(() => {
  return props.role.annual_pay
})
const periodPay = computed(() => {
  return adjustValueForPeriod(props.role.annual_pay)
})
</script>

<template>
  <tr class="hover:bg-gray-50">
    <td class="px-6 py-4 whitespace-nowrap">
      <NuxtLink
        :to="url"
        :prefetch="false"
        class="text-primary-700 hover:text-primary-900 underline"
        @click.prevent="navigateTo(url)"
      >
        {{ role.job_title }}
      </NuxtLink>
    </td>
    <template v-if="activePeriod === 'hourly' || activePeriod === 'annually'">
      <td class="px-6 py-4 whitespace-nowrap text-gray-900">
        {{ formatCurrency(activePeriod === "hourly" ? hourlyPay : hourlyPay) }}
      </td>
      <td class="px-6 py-4 whitespace-nowrap text-gray-900">
        {{
          formatCurrency(activePeriod === "annually" ? annualPay : annualPay)
        }}
      </td>
      <td class="px-6 py-4 whitespace-nowrap text-gray-600">
        {{ formatNumber(role.count) }}
      </td>
    </template>
    <template v-else>
      <td class="px-6 py-4 whitespace-nowrap text-gray-900">
        {{ formatCurrency(periodPay) }}
      </td>
      <td class="px-6 py-4 whitespace-nowrap text-gray-600">
        {{ formatNumber(role.count) }}
      </td>
    </template>
  </tr>
</template>
